import { useTranslation } from 'react-i18next';

import { useDeviceDetails } from '@apis/asset-data-service/queries/use-device-details';
import { Typography } from '@packages/fenrir/components';
import { EMPTY_FIELD_FALLBACK } from 'ae-constants/constants';

import { AssetInformationFieldWrapper } from './asset-information-field-wrapper/asset-information-field-wrapper';

interface AssetInformationCategoryProps {
  assetId: string;
}
export const AssetInformationCategory = ({
  assetId,
}: AssetInformationCategoryProps) => {
  const { t } = useTranslation('ads');
  const { data: device } = useDeviceDetails(assetId);
  const { category } = device ?? {};

  return (
    <AssetInformationFieldWrapper
      assetId={assetId}
      skeletonProps={{ width: '5rem' }}
      term={t('assetDetails.information.category')}
    >
      <Typography variant="body2">
        {category ? t(`category.${category}`) : EMPTY_FIELD_FALLBACK}
      </Typography>
    </AssetInformationFieldWrapper>
  );
};
